module.exports = __webpack_public_path__ + "img/cheatsheet_icon_profile_2x.f7f94b83.png";